$(() => {
  const directory_fee_discount = () => {
    if (net_pt_revenue() <= 2000000000) {
      return 0;
    } else if (net_pt_revenue() <= 6000000000) {
      return 10 / 100;
    } else {
      return 20 / 100;
    }
  };

  const directory_license_fee = () => {
    // =IF(N19=TRUE,(P38+Q38+R38+S38+T38),0)

    // P38; =G23*N38*(1-P32)
    const per_discharge_fee = pt_discharges_per_year() * per_discharge() * (1 - directory_fee_discount());

    // Q38; =G25*O38*(1-P32)
    const per_outpt_fee = outpt_visits_per_year() * per_outpt_visit() * (1 - directory_fee_discount());

    // R38; =0.5*(P38+Q38)
    const provider_search_api = 0.5 * (per_discharge_fee + per_outpt_fee);

    // S38; =0.33*(P38+Q38)
    const provider_schedule_adv = 0.33 * (per_discharge_fee + per_outpt_fee);

    // T38; 48000
    const provider_data_connect = 48000;

    return per_discharge_fee + per_outpt_fee + provider_search_api + provider_schedule_adv + provider_data_connect;
  };

  const provider_license_fee = () => {
    // =IF(N15=TRUE,(IF(AND(G17>=O71,G17<=P71),Q71+S71,IF(AND(G17>=O72,G17<=P72),Q72+S72,IF(AND(G17>=O73,G17<=P73),Q73+S73,IF(AND(G17>=O74,G17<=P74),Q74+S74,IF(G17>=O75,Q75+S75)))))),0)
    if (employed_providers() <= 500) {
      return 50000;
    } else if (employed_providers() <= 1000) {
      return 50000 + (employed_providers() - 501) * 40;
    } else if (employed_providers() <= 5000) {
      return 70000 + (employed_providers() - 1001) * 20;
    } else if (employed_providers() <= 10000) {
      return 150000 + (employed_providers() - 5001) * 5;
    } else {
      return 175000 + (employed_providers() - 10000) * 3;
    }
  };

  const employed_providers = () => {
    return parseInt($('#employed-providers').val().replaceAll(',', ''));
  };

  const net_pt_revenue = () => {
    return parseFloat($('#net-pt-revenue').val().replaceAll(',', ''));
  };

  const outpt_visits_per_year = () => {
    return parseInt($('#outpt-visits-per-year').val().replaceAll(',', ''));
  };

  // N38
  const per_discharge = () => {
    return 2;
  }

  // O38
  const per_outpt_visit = () => {
    return 0.2;
  }

  const pt_discharges_per_year = () => {
    return parseInt($('#pt-discharges-per-year').val().replaceAll(',', ''));
  };

  const calls_per_year = () => {
    // =(3)*(Configurator!G23+Configurator!G25)*0.5
    return Math.round(3 * (pt_discharges_per_year() + outpt_visits_per_year()) * 0.5).toLocaleString("en-US");;
  };

  // const daily_revenue_per_provider = () => {
  //   // =ROUND((2378727/240)*0.2,0)
  // }

  const providers_credentialed_per_month = () => {
    // =ROUNDUP((0.1*Configurator!G17)/12,0)
    return Math.ceil((0.1 * employed_providers()) / 12);
  }

  const med_staff_ftes = () => {
    // =IF(AND(Configurator!$G$17>=$R$7,Configurator!$G$17<=$S$7),$W$7,IF(AND(Configurator!$G$17>=$R$8,Configurator!$G$17<=$S$8),$W$8,IF(Configurator!$G$17>=$R$9,$W$9)))

    if (employed_providers() <= 2000) {
      return Math.ceil(employed_providers() / 150);
    } else if (employed_providers() <= 4000) {
      return Math.ceil(employed_providers() / 200);
    } else {
      return Math.ceil(employed_providers() / 250);
    }
  }

  providers_added_per_yr = () => {
    // =ROUND(0.1*((Configurator!G17/0.7)-Configurator!G17),0)
    return Math.round(0.1 * (employed_providers()/0.7 - employed_providers()));
  };

  avg_credentialing_time = () => {
    // =IF(AND(Configurator!G17>=R28,Configurator!G17<=S28),T28,IF(AND(Configurator!G17>=R29,Configurator!G17<=S29),T29,IF(Configurator!G17>=R30,'Customer Inputs'!T30)))
    if (employed_providers() <= 350) {
      return 90;
    } else if (employed_providers() <= 1500) {
      return 75;
    } else {
      return 60;
    }
  };

  const run = () => {
    if ($('#calls-per-year-overridden').val() === '0') {
      $('#calls-per-year').val(calls_per_year());
    }

    if ($('#providers-credentialed-per-month-overridden').val() === '0') {
      $('#providers-credentialed-per-month').val(providers_credentialed_per_month());
    }

    if ($('#provider-license-fee-overridden').val() === '0') {
      $('#provider-license-fee').val(accounting.formatMoney(provider_license_fee(), '', 0));
    }

    if ($('#directory-license-fee-overridden').val() === '0') {
      $('#directory-license-fee').val(accounting.formatMoney(directory_license_fee(), '', 0));
    }

    if ($('#med-staff-ftes-overridden').val() === '0') {
      $('#med-staff-ftes').val(med_staff_ftes());
    }

    if ($('#providers-added-per-yr-overridden').val() === '0') {
      $('#providers-added-per-yr').val(providers_added_per_yr());
    }

    if ($('#avg-credentialing-time-overridden').val() === '0') {
      $('#avg-credentialing-time').val(avg_credentialing_time());
    }
  };

  $('#outpt-visits-per-year, #pt-discharges-per-year, #employed-providers, #net-pt-revenue, #employed-providers').change(() => {
    run();
  });

  $('#calls-per-year').blur(() => {
    $('#calls-per-year-overridden').val('1');
  });

  // $('#daily-revenue-per-provider').blur(() => {
  //   $('#daily-revenue-per-provider-overridden').val('1');
  // });

  $('#providers-credentialed-per-month').blur(() => {
    $('#providers-credentialed-per-month-overridden').val('1');
  });

  $('#provider-license-fee').blur(() => {
    $('#provider-license-fee-overridden').val('1');
  });

  $('#directory-license-fee').blur(() => {
    $('#directory-license-fee-overridden').val('1');
  });

  $('#med-staff-ftes').blur(() => {
    $('#med-staff-ftes-overridden').val('1');
  });

  $('#providers-added-per-yr').blur(() => {
    $('#providers-added-per-yr-overridden').val('1');
  });

  $('#avg-credentialing-time').blur(() => {
    $('#avg-credentialing-time-overridden').val('1');
  });
});
